import styled from "styled-components";

export const LoaderContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const Spacer = styled.div`
    height: 24px;
    width: 100%;
`;
